import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, LoadScript, Marker, OverlayView } from "@react-google-maps/api";
import { getGoogleMapsApiKey } from "./config.js";
import { useLocation } from "react-router-dom";
import locationPin from "./locationPin.png";

const mapContainerStyle = {
  width: "100%",
  height: "100vh",
};

const defaultCenter = {
  lat: -17.8292,
  lng: 31.0522,
};

const RouteMyLocation = () => {
  const [currentPosition, setCurrentPosition] = useState(defaultCenter);
  const [error, setError] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const mapRef = useRef(null);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const lat = parseFloat(queryParams.get("lat"));
  const lng = parseFloat(queryParams.get("lng"));

  useEffect(() => {
    if (!isNaN(lat) && !isNaN(lng)) {
      setCurrentPosition({ lat, lng });
    } else {
      setError("Invalid or missing coordinates in URL");
    }
  }, [lat, lng]);

  return (
    <div className="relative h-screen">
      <LoadScript
        googleMapsApiKey={getGoogleMapsApiKey()}
        onLoad={() => setMapLoaded(true)}
      >
        {mapLoaded && (
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={currentPosition}
            zoom={16}
            onLoad={(map) => (mapRef.current = map)}
          >
            {/* Pulse Effect */}
            <OverlayView
              position={currentPosition}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div
                style={{
                  width: "150px",             // wider
                  height: "150px",            // taller
                  backgroundColor: "rgba(123,44,191,0.3)",
                  borderRadius: "50%",
                  animation: "pulse 3s infinite",
                  transform: "translate(-100%, -100%)", // move slightly above the pin
                  zIndex: 1,
                }}
              />
            </OverlayView>


            {/* Marker */}
            <Marker
              position={currentPosition}
              icon={{
                url: locationPin,
                scaledSize: new window.google.maps.Size(50, 100),
              }}
              animation={window.google.maps.Animation.BOUNCE}
            />

            {/* Label using OverlayView */}
            <OverlayView
              position={currentPosition}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div
                style={{
                  backgroundColor: "#562cbfff",
                  color: "white",
                  padding: "10px 15px",
                  borderRadius: "70px",
                  width: "180px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                  transform: "translate(-50%, -500%)", // above the marker
                  zIndex: 10,
                }}
              >
                📍 You are here
              </div>
            </OverlayView>

            {/* Pulse Animation Keyframes */}
            <style>
              {`
                @keyframes pulse {
                  0% { transform: translate(-50%, -50%) scale(0.7); opacity: 0.7; }
                  50% { transform: translate(-50%, -50%) scale(1.2); opacity: 0.3; }
                  100% { transform: translate(-50%, -50%) scale(0.7); opacity: 0.7; }
                }
              `}
            </style>
          </GoogleMap>
        )}
      </LoadScript>

      {/* Error Display */}
      {error && (
        <div className="absolute bottom-4 left-4 bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded shadow-lg">
          {error}
        </div>
      )}
    </div>
  );
};

export default RouteMyLocation;
